document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      var elementPosition = document.querySelector(this.getAttribute('href')).offsetTop;
      window.scrollTo({
        top: elementPosition - 130, //add your necessary value
        behavior: "smooth"  //Smooth transition to roll
      });
  });
});

(function () {
  const handleHidingOmniSendFormBasedOnUrlName = (name) => {
    if (window.location.href.indexOf(name) > -1) {
      // Usually omnisend
      const htmlSection = document.getElementById("shopify-section-html");
      htmlSection.style.display = "none";
    }
  }

  handleHidingOmniSendFormBasedOnUrlName("essen-auf-raedern-nuernberg")
})()